// Styles
import { createTheme } from "@mui/material/styles";

// Assets
import colors from "assets/theme/base/colors";
import breakpoints from "assets/theme/base/breakpoints";
import typography from "assets/theme/base/typography";
import boxShadows from "assets/theme/base/boxShadows";

function theme({ rowPointer, mode = "light" }) {
  const isDark = mode === "dark";

  return createTheme({
    breakpoints: { ...breakpoints },
    palette: {
      mode,
      ...(isDark ? colors.dark : colors.light),
    },
    typography: { ...typography },
    boxShadows: { ...boxShadows },
    components: {
      MUIDataTable: {
        styleOverrides: {
          root: {
            backgroundColor: isDark ? "#1a2332" : "#FFFFFF",
            boxShadow: "None",
            overflowX: "auto",
            height: "100%",
          },
        },
      },
      MuiDataTableHeadCell: {
        styleOverrides: {
          fixedHeader: {
            justifyContent: "center",
            textAlign: "center",
          },
        },
      },
      MUIDataTableHeadCell: {
        styleOverrides: {
          contentWrapper: {
            justifyContent: "center",
            textAlign: "center",
          },
          toolButton: {
            padding: 0,
            margin: 0,
          },
        },
      },
      MuiTableHead: {
        styleOverrides: {
          root: {
            "& .MuiButton-root": {
              color: isDark ? "rgba(208, 218, 230, 0.9)" : "#494d53",
              fontSize: "0.7rem",
              fontWeight: 700,
              textTransform: "uppercase",
              textAlign: "center",
            },
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          head: {
            color: isDark ? "rgba(208, 218, 230, 0.9)" : "#494d53",
            fontSize: "0.7rem",
            fontWeight: 700,
            textTransform: "uppercase",
            textAlign: "center",
            borderBottom: isDark
              ? "1px solid rgba(255, 255, 255, 0.12)"
              : "1px solid rgba(224, 224, 224, 1)",
          },
          root: {
            textAlign: "center",
            justifyContent: "center",
            color: isDark ? "#f0f4f8" : "#494d53",
            borderBottom: isDark
              ? "1px solid rgba(255, 255, 255, 0.12)"
              : "1px solid rgba(224, 224, 224, 1)",
          },
        },
      },
      MuiTypography: {
        styleOverrides: {
          root: {
            color: isDark ? "#f0f4f8" : "#494d53",
            fontSize: "0.7rem",
          },
        },
      },
      MuiTableFooter: {
        styleOverrides: {
          root: {
            "& .MuiTablePagination-selectLabel ": {
              color: isDark ? "#d0dae6" : "#494d53",
              fontSize: "0.7rem",
            },
            "& .MuiTablePagination-displayedRows": {
              color: isDark ? "#d0dae6" : "#494d53",
            },
            "& .MuiSelect-select": {
              color: isDark ? "#f0f4f8" : "#494d53",
            },
            "& .MuiSvgIcon-root": {
              color: isDark ? "#d0dae6" : "#494d53",
            },
          },
        },
      },
      MuiTooltip: {
        styleOverrides: {
          tooltip: isDark
            ? {
                backgroundColor: "#e2e8f0",
                color: "#1a2332",
                fontSize: "0.75rem",
              }
            : {},
        },
      },
      MuiTableRow: {
        styleOverrides: {
          root: {
            cursor: rowPointer,
          },
        },
      },
    },
  });
}

export default theme;
